import { SmartDialog } from '../../../generic/utilities/SmartDialog'

const MosSmartDialog = (props) => {
  return (
    <SmartDialog
      {...props}
      renderComponent={props.children}
    />
  )
}

export default MosSmartDialog
